module.exports = __webpack_public_path__ + "wpicons.f243e6a89bb535d1aed6.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/assets/fonts/wpicons.ttf
// module id = ../../../../../src/assets/fonts/wpicons.ttf
// module chunks = 2